import {
    Actions,
    DOWNLOAD_PDF,
    DOWNLOAD_PDF_ERROR,
    DOWNLOAD_PDF_SUCCESS,
    RESET_DOWNLOAD_PDF,
    State,
    initialState
} from "../../types/inspection/download-pdf";


const reducers = (
    state = initialState,
    action: Actions
): State => {
    switch (action.type) {

        case DOWNLOAD_PDF:
            return {
                ...state,
                states: {
                    loading: true,
                    success: false,
                    error: false,
                },
            }
        case DOWNLOAD_PDF_SUCCESS:
            return {
                ...state,
                states: {
                    loading: false,
                    success: true,
                    error: false,
                },
            }
        case DOWNLOAD_PDF_ERROR:
            return {
                ...state,
                states: {
                    loading: false,
                    success: false,
                    error: action.payload,
                },
            }
        case RESET_DOWNLOAD_PDF:
            return {
                ...state,
                states: {
                    loading: false,
                    success: false,
                    error: false,
                },
            }
        default:
            return state;
    }
}

export default reducers;